import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import requester from "../../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import _ from "lodash";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import XLSX from "xlsx";

class ReportSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedInvoiceNo: "",
      selectedCustomer: "",
      orgName: "",
      orgSource: "",
      statusDocument: "",
      dataTable: [],
      lovBranch: [],
      loading: false,
      Param_SubmitFrom: new Date(),
      Param_SubmitTo: new Date(),
    };
  }

  componentDidMount = () => {
    this.getBranch();
  };

  getBranch = () => {
    let url = "/api/traces/v1/general/list-cabang";
    requester.getTraces(url, {
      success: function (response) {
        this.setState({ lovBranch: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  handleSearch = () => {
    let url = "/api/collect/v1/report-document/doc-monitoring-summary";
    let param = {
      startDate: this.state.Param_SubmitFrom,
      endDate: this.state.Param_SubmitTo,
      invoiceNumber: this.state.selectedInvoiceNo,
      orgName: this.state.orgName,
      orgSource: this.state.orgSource,
      status: this.state.statusDocument,
      export: false,
    };
    this.setState({ loading: true });
    requester.postCollect(url, param, {
      success: function (response) {
        let { data } = response.data;
        this.setState({ loading: false, dataTable: data });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
        console.log(e.message);
      }.bind(this),
    });
  };

  handleExport = () => {
    let data = this.state.dataTable;
    if (data.length > 0) {
      this.setState({ loading: true });

      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(data, { raw: false });
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "REPORT_DOC_MONITORING_" + moment(new Date()).format("DDMMYYYY") + ".xlsx");
      this.setState({ loading: false });
    } else {
      alert("No Data to be Exported !");
    }
    // let url = '/api/collect/v1/report-document/doc-monitoring-summary'
    // let param = {
    //   startDate: this.state.Param_SubmitFrom,
    //   endDate: this.state.Param_SubmitTo,
    //   invoiceNumber: this.state.selectedInvoiceNo,
    //   orgName: this.state.orgName,
    //   export: true
    // }
    // this.setState({ loading: true })
    // requester.postCollect(url, param, {
    //   success: function (response) {
    //     let { data } = response.data
    //     const workBook = XLSX.utils.book_new(); // create a new blank book
    //     const workSheet = XLSX.utils.json_to_sheet(data, { raw: false });
    //     XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
    //     XLSX.writeFile(
    //       workBook,
    //       "REPORT_DOC_MONITORING_" + moment(new Date()).format('DDMMYYYY') + ".xlsx"
    //     );
    //     this.setState({ dataTable: data, loading: false})
    //   }.bind(this),
    //   error: function (e) {
    //     this.setState({ loading: false })
    //     console.log(e.message)
    //   }.bind(this)
    // })
  };

  handleChangeInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };

  renderFilter = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-3">
                  <label>Sender</label>
                  <select className="form-control" name="orgSource" onChange={this.handleChangeInput.bind(this)}>
                    <option value="">ALL</option>
                    {this.state.lovBranch.map((item, index) => (
                      <option value={item.org_name} key={index}>
                        {item.org_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label>Destination</label>
                  <select className="form-control" name="orgName" onChange={this.handleChangeInput.bind(this)}>
                    <option value="">ALL</option>
                    {this.state.lovBranch.map((item, index) => (
                      <option value={item.org_name} key={index}>
                        {item.org_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-3">
                  <label>Invoice No</label>
                  <input type="text" className="form-control" value={this.state.selectedInvoiceNo} name="selectedInvoiceNo" onChange={this.handleChangeInput.bind(this)} />
                </div>
                <div className="col-md-3">
                  <div className="">
                    <label>Submitted (From)</label>
                    <div className="customDatePickerWidth">
                      <DatePicker placeholder="Submitted Date from" selected={this.state.Param_SubmitFrom} dateFormat="d-MMM-yyyy" className="form-control myDatePicker" popperPlacement="bottom-end" onChange={this.handleSubmittedDateFrom} />
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="">
                    <label>Submitted (To)</label>
                    <div className="customDatePickerWidth">
                      <DatePicker placeholder="Submitted Date from" selected={this.state.Param_SubmitTo} dateFormat="d-MMM-yyyy" className="form-control myDatePicker" popperPlacement="bottom-end" onChange={this.handleSubmittedDateTo} />
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <label>Status Document</label>
                  <select className="form-control" onChange={this.handleChangeInput.bind(this)} name="statusDocument">
                    <option value="">All Status</option>
                    <option value={"IN TRANSIT"}>IN TRANSIT</option>
                    <option value={"APPROVE"}>APPROVE</option>
                    <option value={"REJECT"}>REJECT</option>
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="">
                    <label>&nbsp;</label>
                    <button className="btn btn-primary btn-block" onClick={this.handleSearch.bind(this)}>
                      <i className="fa fa-search"></i> Search
                    </button>
                  </div>
                </div>
                <div className="col-md-3">
                  <label>&nbsp;</label>
                  <button className="btn btn-success btn-block" onClick={this.handleExport.bind(this)}>
                    <i className="fa fa-file-excel"></i> Export
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "SENDER",
          accessor: "SENDER",
          filterable: true,
        },
        {
          Header: "DESTINATION",
          accessor: "DESTINATION",
          filterable: true,
        },
        {
          Header: "SUBMITTED BY",
          accessor: "SUBMITTED_BY",
          filterable: true,
        },
        {
          Header: "SUBMITTED DATE",
          accessor: "SUBMITTED_DATE",
          filterable: true,
        },
        {
          Header: "POSISI",
          accessor: "POSITION",
          filterable: true,
        },
        {
          Header: "TYPE",
          accessor: "TYPE",
          filterable: true,
        },
        {
          Header: "DOC NUMBER",
          accessor: "DOC_NO",
          filterable: true,
        },
        {
          Header: "DOC DATE",
          accessor: "DOC_DATE",
          filterable: true,
        },
        {
          Header: "AWB NO",
          accessor: "AWB_NO",
          filterable: true,
        },
        {
          Header: "AWB DATE",
          accessor: "AWB_DATE",
          filterable: true,
        },
        {
          Header: "NO PO",
          accessor: "NO_PO",
          filterable: true,
        },
        {
          Header: "INVOICE NO",
          accessor: "INVOICE_NUMBER",
          filterable: true,
        },
        {
          Header: "INVOICE DATE",
          accessor: "INVOICE_DATE",
          filterable: true,
        },
        {
          Header: "NO TTF",
          accessor: "TTF_AAM",
          filterable: true,
        },
        {
          Header: "INVOICE REMAINING",
          accessor: "INVOICE_OUTSTANDING_AMOUNT",
          filterable: true,
        },
        {
          Header: "STATUS Doc",
          accessor: "STATUS_DOCUMENT",
          filterable: true,
        },
        {
          Header: "STATUS Line",
          accessor: "STATUS_LINE",
          filterable: true,
        },
        {
          Header: "STATUS TTF",
          accessor: "STATUS_TTF",
          filterable: true,
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <div className="row">
        <div className="col-12 text-right">
          <div className="col-12 mt-2 px-0">
            <ReactTable
              className="fullWidth"
              data={data.rows}
              columns={data.columns}
              defaultPageSize={10}
              defaultFilterMethod={(filter, row, column) => {
                let columnes = row[filter.id];
                return columnes ? columnes.toLowerCase().includes(filter.value.toLowerCase()) : "";
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  handleSubmittedDateFrom = (date) => {
    this.setState({ Param_SubmitFrom: date });
  };

  handleSubmittedDateTo = (date) => {
    this.setState({ Param_SubmitTo: date });
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className='card-header'>Report Detail Document Monitoring</div>
                  <div className='card-body'>
                    {this.renderFilter()}
                    <div className='clearfix'>&nbsp;</div>
                    <div className='row'>
                      <div className='col-lg-12'>{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Loader fullPage loading={this.state.loading} />
      </div>
    );
  }
}

export default ReportSummary;
